<template>
    <div id="description" class="tab-content">
        <p class="md:px-8 lg:px-24" v-html="description"></p>
    </div>
</template>
<script>
export default {
    props: ["data", "description"],
    computed: {}
};
</script>
